import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PendingChangesGuard } from '../../guards/pending-changes.guard';
import { SupplierInboxSubType } from '../../enums/supplier-inbox-sub-type.enum';
import { SupplierJobsInboxModule } from '../driver-experience/job-list/supplier-jobs-inbox.module';
import { CustomerUserDeactivationAdminModule } from '../../components/customer-user-deactivation-admin/customer-user-deactivation-admin.module';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../../components/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'dashboard-summary',
    loadChildren: () =>
      import('../../components/dashboard-summary/dashboard-summary.module').then(
        (m) => m.DashboardSummaryModule,
      ),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('../../components/settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: 'auditchanges',
    loadChildren: () =>
      import('../../components/auditchanges/auditchanges.module').then((m) => m.AuditChangesModule),
  },
  {
    path: 'mobile-logging',
    loadChildren: () =>
      import('../../components/mobile-logging/mobile-logging.module').then(
        (m) => m.MobileLoggingModule,
      ),
  },

  {
    path: 'email-templates',
    loadChildren: () =>
      import('../../components/email-templates/email-templates.module').then(
        (m) => m.EmailTemplatesModule,
      ),
  },
  {
    path: 'email-template-form/:id',
    loadChildren: () =>
      import('../../components/email-templates/email-template-form.module').then(
        (m) => m.EmailTemplateFormModule,
      ),
  },
  {
    path: 'email-template-test',
    loadChildren: () =>
      import('../../components/email-templates/email-template-test.module').then(
        (m) => m.EmailTemplateTestModule,
      ),
  },
  {
    path: 'eregionpostcodes',
    loadChildren: () =>
      import('../lazy-loaded/eregionpostcodes.module').then((m) => m.ERegionPostCodesModule),
  },
  {
    path: 'eregions',
    loadChildren: () => import('../lazy-loaded/eregions.module').then((m) => m.ERegionsModule),
  },
  {
    path: 'eareas',
    loadChildren: () => import('../lazy-loaded/eareas.module').then((m) => m.EAreasModule),
  },
  {
    path: 'debugprice',
    loadChildren: () =>
      import('../../components/debug-pricecalc/debug-pricecalc.module').then(
        (m) => m.DebugPriceCalcModule,
      ),
    data: { title: '' },
  },
  {
    path: 'joblist',
    loadChildren: () =>
      import('../../components/vme-jobs/vme-jobs.module').then((m) => m.VmeJobsModule),
  },
  {
    path: 'postcodes',
    loadChildren: () => import('../lazy-loaded/postcodes.module').then((m) => m.PostCodesModule),
  },
  {
    path: 'orgstructurecustomer',
    loadChildren: () =>
      import('../../components/manage-org-structure/org-structure-customer.module').then(
        (m) => m.OrgStructureCustomerModule,
      ),
  },
  {
    path: 'orgstructuresupplier',
    loadChildren: () =>
      import('../../components/manage-org-structure/org-structure-supplier.module').then(
        (m) => m.OrgStructureSupplierModule,
      ),
  },
  {
    path: 'ratecard',
    loadChildren: () =>
      import('../../components/rate-cards/rate-cards.module').then((m) => m.RateCardsModule),
  },
  {
    path: 'agreement',
    loadChildren: () => import('../lazy-loaded/agreement.module').then((m) => m.AgreementModule),
  },
  {
    path: 'agreement/:type',
    loadChildren: () => import('../lazy-loaded/agreement.module').then((m) => m.AgreementModule),
  },
  {
    path: 'agreement/:type/:orgId',
    loadChildren: () => import('../lazy-loaded/agreement.module').then((m) => m.AgreementModule),
  },
  {
    path: 'agreement/:type/:orgId/:deptId',
    loadChildren: () => import('../lazy-loaded/agreement.module').then((m) => m.AgreementModule),
  },
  {
    path: 'agreementcustomer',
    loadChildren: () => import('../lazy-loaded/agreement.module').then((m) => m.AgreementModule),
  },
  {
    path: 'agreementsupplier',
    loadChildren: () => import('../lazy-loaded/agreement.module').then((m) => m.AgreementModule),
  },
  {
    path: 'job-alert-settings-supplier',
    loadChildren: () =>
      import('../../components/job-alert-settings/job-alert-settings-supplier.module').then(
        (m) => m.JobAlertSettingsSupplierModule,
      ),
  },
  {
    path: 'checklist-categories',
    loadChildren: () =>
      import('../../components/checklist-categories/checklist-categories.module').then(
        (m) => m.ChecklistCategoriesModule,
      ),
  },
  {
    path: 'customer-priority',
    loadChildren: () =>
      import('../../components/customer-priority/customer-priority.module').then(
        (m) => m.CustomerPriorityModule,
      ),
  },
  {
    path: 'checklist-steps',
    loadChildren: () =>
      import('../../components/checklist-steps/checklist-steps.module').then(
        (m) => m.ChecklistStepsModule,
      ),
  },
  {
    path: 'job-unassigned-reasons',
    loadChildren: () =>
      import('../../components/job-unassigned-reasons/job-unassigned-reasons.module').then(
        (m) => m.JobUnassignedReasonsModule,
      ),
  },
  {
    path: 'job-deployment-priority',
    loadChildren: () =>
      import('../../components/deploy-priority/deploy-priority.module').then(
        (m) => m.DeployPriorityModule,
      ),
  },
  {
    path: 'job-alert-settings-admin',
    loadChildren: () =>
      import('../../components/job-alert-settings/job-alert-settings-admin.module').then(
        (m) => m.JobAlertSettingsAdminModule,
      ),
  },
  {
    path: 'auto-direct',
    loadChildren: () =>
      import('../../components/auto-direct/auto-direct.module').then((m) => m.AutoDirectModule),
  },
  {
    path: 'job-list-item/:id',
    loadChildren: () =>
      import('../driver-experience/job-list-item/job-list-item.module').then(
        (m) => m.JobListItemModule,
      ),
  },
  {
    path: 'bespokeagreements/:type',
    loadChildren: () =>
      import('../../components/agreement/bespoke-agreements.module').then(
        (m) => m.BespokeAgreementsModule,
      ),
  },
  {
    path: 'valettypes',
    loadChildren: () =>
      import('../../components/manage-valet-type/manage-valet-type.module').then(
        (m) => m.ManageValetTypeModule,
      ),
  },
  {
    path: 'inspectiontypes',
    loadChildren: () =>
      import('../../components/manage-inspection-types/manage-inspection-types.module').then(
        (m) => m.ManageInspectionTypesModule,
      ),
  },
  {
    path: 'customtaskactions',
    loadChildren: () =>
      import('../../components/manage-task-custom-action/manage-task-custom-action.module').then(
        (m) => m.ManageTaskCustomActionModule,
      ),
  },
  {
    path: 'driver-location-view',
    loadChildren: () =>
      import('../../components/driver-location-view/driver-location-view.module').then(
        (m) => m.DriverLocationViewModule,
      ),
  },
  {
    path: 'vehicletypes',
    loadChildren: () =>
      import('../../components/manage-vehicle-type/manage-vehicle-type.module').then(
        (m) => m.ManageVehicleTypeModule,
      ),
  },
  {
    path: 'vatrates',
    loadChildren: () =>
      import('../../components/manage-vatrate/manage-vatrate.module').then(
        (m) => m.ManageVatrateModule,
      ),
  },
  {
    path: 'dispute',
    loadChildren: () =>
      import('../../components/dispute/dispute.module').then((m) => m.DisputeModule),
  },
  {
    path: 'disputecs',
    loadChildren: () =>
      import('../../components/dispute/dispute.module').then((m) => m.DisputeModule),
  },
  {
    path: 'preferredsuppliers',
    loadChildren: () =>
      import('../../components/preferred-supplier/preferred-supplier.module').then(
        (m) => m.PreferredSupplierModule,
      ),
  },
  {
    path: 'preferredsuppliers/:id/:status',
    loadChildren: () =>
      import('../../components/preferred-supplier-details/preferred-supplier-details.module').then(
        (m) => m.PreferredSupplierDetailsModule,
      ),
  },
  {
    path: 'organisations',
    loadChildren: () =>
      import('../../components/customer/customer.module').then((m) => m.CustomerModule),
    data: { title: 'Organisations', orgTypeId: 1 },
  },
  {
    path: 'organisations/:id',
    loadChildren: () =>
      import('../../components/customer/customer-details.module').then(
        (m) => m.CustomerDetailsModule,
      ),
    data: { title: 'Organisation Details' },
  },
  {
    path: 'organisation/:id',
    loadChildren: () =>
      import('../../components/customer/customer-details.module').then(
        (m) => m.CustomerDetailsModule,
      ),
    data: { title: 'Organisation Details' },
  },
  {
    path: 'customers',
    loadChildren: () =>
      import('../../components/customer/customer.module').then((m) => m.CustomerModule),
    data: { title: 'Customers', orgTypeId: 3 },
  },
  {
    path: 'customers/driverchecklistadmin',
    loadChildren: () =>
      import(
        '../../components/organisations-specific-steps/organisations-specific-steps-admin/organisations-specific-steps-admin.module'
      ).then((m) => m.OrganisationsSpecificStepsAdminModule),
    data: { title: 'Checklist Admin' },
  },
  {
    path: 'customers/driverchecklistcustomer',
    loadChildren: () =>
      import(
        '../../components/organisations-specific-steps/organisations-specific-steps.module'
      ).then((m) => m.OrganisationsSpecificStepsModule),
    data: { title: 'Driver Checklist' },
  },
  {
    path: 'customers/driverchecklistsupplier',
    loadChildren: () =>
      import(
        '../../components/organisations-specific-steps/organisations-specific-steps.module'
      ).then((m) => m.OrganisationsSpecificStepsModule),
    data: { title: 'Driver Checklist' },
  },
  {
    path: 'customers/photos',
    loadChildren: () =>
      import('../../components/customer-photos/customer-photos.module').then(
        (m) => m.CustomerPhotosModule,
      ),
    data: { title: 'Customer Steps & Photos' },
  },
  {
    path: 'customers/photos/:id',
    loadChildren: () =>
      import('../../components/customer-photos/customer-photos-details.module').then(
        (m) => m.CustomerPhotosDetailsModule,
      ),
    data: { title: 'Customer Steps & Photos Details' },
  },
  {
    path: 'customer-photos',
    loadChildren: () =>
      import('../../components/customer-photos/customer-photos-details.module').then(
        (m) => m.CustomerPhotosDetailsModule,
      ),
    data: { title: 'Mandatory Photo Mapping' },
  },
  {
    path: 'customers/:id',
    loadChildren: () =>
      import('../../components/customer/customer-details.module').then(
        (m) => m.CustomerDetailsModule,
      ),
    data: { title: 'Customer details' },
  },
  {
    path: 'scorecards',
    loadChildren: () =>
      import('../../components/score-cards/score-cards.module').then((m) => m.ScoreCardsModule),
  },
  {
    path: 'storagetypes',
    loadChildren: () =>
      import('../../components/manage-storage-type/manage-storage-type.module').then(
        (m) => m.ManageStorageTypeModule,
      ),
  },
  {
    path: 'licensetypes',
    loadChildren: () =>
      import('../../components/manage-license-types/manage-license-types.module').then(
        (m) => m.ManageLicenseTypesModule,
      ),
  },
  {
    path: 'trucks',
    loadChildren: () =>
      import('../../components/manage-trucks/manage-trucks.module').then(
        (m) => m.ManageTrucksModule,
      ),
  },
  {
    path: 'truck/:id',
    loadChildren: () =>
      import('../../components/manage-trucks/truck-details.module').then(
        (m) => m.TruckDetailsModule,
      ),
  },
  {
    path: 'newtruck',
    loadChildren: () =>
      import('../../components/manage-trucks/new-truck.module').then((m) => m.NewTruckModule),
  },
  {
    path: 'accountcodes/:id',
    loadChildren: () =>
      import('../../components/manage-account-code/manage-account-code.module').then(
        (m) => m.ManageAccountCodeModule,
      ),
  },
  {
    path: 'accountcodescustomer',
    loadChildren: () =>
      import('../../components/manage-account-code/manage-account-code.module').then(
        (m) => m.ManageAccountCodeModule,
      ),
  },
  {
    path: 'accountcodessupplier',
    loadChildren: () =>
      import('../../components/manage-account-code/manage-account-code.module').then(
        (m) => m.ManageAccountCodeModule,
      ),
  },
  {
    path: 'jobtagscustomer',
    loadChildren: () =>
      import('../../components/manage-job-tag/job-tag.module').then((m) => m.JobTagModule),
  },
  {
    path: 'jobtagssupplier',
    loadChildren: () =>
      import('../../components/manage-job-tag/job-tag.module').then((m) => m.JobTagModule),
  },
  {
    path: 'job/create/:type',
    loadChildren: () =>
      import('../lazy-loaded/create-movement-job.module').then((m) => m.CreateMovementJobModule),
    data: { title: 'Create Movement Job' },
  },
  {
    path: 'order/copy/:orderId',
    loadChildren: () =>
      import('../lazy-loaded/create-movement-job.module').then((m) => m.CreateMovementJobModule),
    data: { title: 'Copy Order' },
  },
  {
    path: 'order/upload',
    loadChildren: () =>
      import('../../components/order-uploads/order-upload.module').then((m) => m.OrderUploadModule),
  },
  {
    path: 'orderdetails/:id',
    loadChildren: () =>
      import('../../components/manage-orders/order-details.module').then(
        (m) => m.OrderDetailsModule,
      ),
  },
  {
    path: 'mobilebranding',
    loadChildren: () =>
      import('../../components/mobile-branding/mobile-branding.module').then(
        (m) => m.MobileBrandingModule,
      ),
  },
  {
    path: 'drivers',
    loadChildren: () =>
      import('../../components/manage-driver/manage-driver.module').then(
        (m) => m.ManageDriverModule,
      ),
  },
  {
    path: 'vmeusers',
    loadChildren: () => import('../../components/users/users.module').then((m) => m.UsersModule),
    data: { title: 'Users', orgTypeId: 1 },
  },
  {
    path: 'engineius-users',
    loadChildren: () => import('../../components/users/users.module').then((m) => m.UsersModule),
    data: { title: 'Users', orgTypeId: 1 },
  },
  {
    path: 'vmeusers/:orgId',
    loadChildren: () => import('../../components/users/users.module').then((m) => m.UsersModule),
    data: { title: 'Users', orgTypeId: 1 },
  },
  {
    path: 'customerusers',
    loadChildren: () => import('../../components/users/users.module').then((m) => m.UsersModule),
    data: { title: 'Users', orgTypeId: 2 },
  },
  {
    path: 'supplierusers',
    loadChildren: () => import('../../components/users/users.module').then((m) => m.UsersModule),
    data: { title: 'Users', orgTypeId: 3 },
  },
  {
    path: 'saasusers',
    loadChildren: () => import('../../components/users/users.module').then((m) => m.UsersModule),
    data: { title: 'Users', orgTypeId: 5 },
  },
  {
    path: 'emergency-contact/:userId',
    loadChildren: () =>
      import('../../components/users/emergency-contact/emergency-contact.module').then(
        (m) => m.EmergencyContactModule,
      ),
    data: { title: 'Emergency Contact' },
  },
  {
    path: 'emergency-contact',
    loadChildren: () =>
      import('../../components/users/emergency-contact/emergency-contact.module').then(
        (m) => m.EmergencyContactModule,
      ),
    data: { title: 'Emergency Contact' },
  },
  {
    path: 'newuser/:orgType',
    loadChildren: () =>
      import('../../components/users/common-users/new-user.module').then((m) => m.NewUserModule),
  },
  {
    path: 'dataimport/:id',
    loadChildren: () =>
      import('../../components/data-import/data-import.module').then((m) => m.DataImportModule),
  },
  {
    path: 'vmeuserdetails/:id',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'User Details', orgTypeId: 1 },
  },
  {
    path: 'vmeuserdetails',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'New User', orgTypeId: 1, orgId: 0 },
  },
  {
    path: 'engineius-user-details/:id',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'User Details', orgTypeId: 1 },
  },
  {
    path: 'engineius-user-details',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'New User', orgTypeId: 1, orgId: 0 },
  },
  {
    path: 'customerdetails/:id',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'User Details', orgTypeId: 2 },
  },
  {
    path: 'customerdetails',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'New User', orgTypeId: 2 },
  },
  {
    path: 'supplierdetails/:id',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'User Details', orgTypeId: 3 },
  },
  {
    path: 'supplierdetails',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'New User', orgTypeId: 3 },
  },
  {
    path: 'saasdetails/:id',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'User Details', orgTypeId: 5 },
  },
  {
    path: 'saasdetails',
    loadChildren: () =>
      import('../../components/users/new-user-details.module').then((m) => m.NewUserDetailsModule),
    data: { title: 'New User', orgTypeId: 5 },
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('../../components/profile/user-profile.module').then((m) => m.UserProfileModule),
  },
  {
    path: 'userrequests',
    loadChildren: () =>
      import('../../components/user-request/user-requests.module').then(
        (m) => m.UserRequestsModule,
      ),
  },
  {
    path: 'vmeinbox',
    loadChildren: () =>
      import('../../components/jobs-inbox/vme-jobs-inbox.module').then((m) => m.VmeJobsInboxModule),
  },
  {
    path: 'vmeinbox/:inboxType',
    loadChildren: () =>
      import('../../components/jobs-inbox/vme-jobs-inbox.module').then((m) => m.VmeJobsInboxModule),
  },
  {
    path: 'geodata',
    loadChildren: () =>
      import('../../components/geo-data/geo-data.module').then((m) => m.GeoDataModule),
  },
  {
    path: 'adhocsearch',
    loadChildren: () =>
      import('../../components/jobs-inbox/ad-hoc-search.module').then((m) => m.AdHocSearchModule),
  },
  {
    path: 'routes-inbox',
    loadChildren: () =>
      import('../driver-experience/job-list/planned-routes.module').then(
        (m) => m.PlannedRoutesModule,
      ),
  },
  {
    path: 'supplierinbox',
    loadChildren: () =>
      import('../driver-experience/job-list/supplier-jobs-inbox.module').then(
        (m) => m.SupplierJobsInboxModule,
      ),
    data: { title: 'Inbox', inboxSubTypeId: SupplierInboxSubType.JobSearch },
  },
  {
    path: 'planned-route-detail/:id',
    loadChildren: () =>
      import('../../components/job-screen/job-screen-container.module').then(
        (m) => m.JobScreenContainerModule,
      ),
    data: { title: 'Planned Route Detail', isRoute: true },
  },
  {
    path: 'customerinbox',
    loadChildren: () =>
      import('../../components/jobs-inbox/customer-jobs-inbox.module').then(
        (m) => m.CustomerJobsInboxModule,
      ),
  },
  {
    path: 'existingjobs',
    loadChildren: () =>
      import('../driver-experience/job-list/supplier-jobs-inbox.module').then(
        (m) => m.SupplierJobsInboxModule,
      ),
    data: { title: 'Existing Jobs', inboxSubTypeId: SupplierInboxSubType.ExistingJobs },
  },
  {
    path: 'jobscreen/:id',
    loadChildren: () =>
      import('../../components/job-screen/job-screen-container.module').then(
        (m) => m.JobScreenContainerModule,
      ),
  },
  {
    path: 'jobsearch/:data',
    loadChildren: () =>
      import('../../components/job-control/job-search.module').then((m) => m.JobSearchModule),
  },
  {
    path: 'report',
    loadChildren: () =>
      import('../../components/reports/report.module').then((m) => m.ReportModule),
  },
  {
    path: 'termsconditions',
    loadChildren: () =>
      import('../../components/terms-conditions/terms-conditions.module').then(
        (m) => m.TermsConditionsModule,
      ),
  },
  {
    path: 'termsconditionslist',
    loadChildren: () =>
      import('../../components/terms-conditions/terms-conditions-list.module').then(
        (m) => m.TermsConditionsListModule,
      ),
  },
  {
    path: 'edit-task-location/:id',
    loadChildren: () =>
      import('../../components/job-control/edit-task-location.module').then(
        (m) => m.EditTaskLocationModule,
      ),
  },
  {
    path: 'searchsupplier/:id',
    loadChildren: () =>
      import('../../components/job-control/search-supplier.module').then(
        (m) => m.SearchSupplierModule,
      ),
  },
  {
    path: 'orderdump',
    loadChildren: () =>
      import('../../components/order-dump/order-dump.module').then((m) => m.OrderDumpModule),
  },
  {
    path: 'bankaccount',
    loadChildren: () =>
      import('../../components/bank/new-bank-details.module').then((m) => m.NewBankDetailsModule),
  },
  {
    path: 'pricedetails',
    loadChildren: () =>
      import('../../components/jobs-inbox/price-details.module').then((m) => m.PriceDetailsModule),
  },
  {
    path: 'jobsfordelete',
    loadChildren: () =>
      import('../../components/job-control/job-delete.module').then((m) => m.JobDeleteModule),
  },
  {
    path: 'invoices',
    loadChildren: () =>
      import('../../components/manage-invoices/manage-invoices.module').then(
        (m) => m.ManageInvoicesModule,
      ),
  },
  {
    path: 'customerinvoices',
    loadChildren: () =>
      import('../../components/manage-invoices/customer-invoices.module').then(
        (m) => m.CustomerInvoicesModule,
      ),
  },
  {
    path: 'supplierinvoices',
    loadChildren: () =>
      import('../../components/manage-invoices/supplier-invoices.module').then(
        (m) => m.SupplierInvoicesModule,
      ),
  },
  {
    path: 'selfbilling',
    loadChildren: () =>
      import('../../components/manage-invoices/manage-self-billing.module').then(
        (m) => m.ManageSelfBillingModule,
      ),
  },
  {
    path: 'supplierselfbilling',
    loadChildren: () =>
      import('../../components/manage-invoices/supplier-self-billing.module').then(
        (m) => m.SupplierSelfBillingModule,
      ),
  },
  {
    path: 'manage-weight',
    loadChildren: () =>
      import('../../components/manage-postcodes-weight/manage-weight.module').then(
        (m) => m.ManageWeightModule,
      ),
  },
  {
    path: 'manage-discount-lookup',
    loadChildren: () =>
      import('../../components/manage-discount-lookup/manage-discount-lookup.module').then(
        (m) => m.ManageDiscountLookupModule,
      ),
  },
  {
    path: 'manage-b2c-discount',
    loadChildren: () =>
      import('../../components/manage-b2c-discount/manage-b2c-discount.module').then(
        (m) => m.ManageB2CDiscountModule,
      ),
  },
  {
    path: 'manage-long-distance-time-bands',
    loadChildren: () =>
      import(
        '../../components/manage-long-distance-time-bands/manage-long-distance-time-bands.module'
      ).then((m) => m.ManageLongDistanceTimeBandsModule),
  },
  {
    path: 'insurance-providers',
    loadChildren: () =>
      import('../../components/insurance-providers/insurance-providers.module').then(
        (m) => m.InsuranceProvidersModule,
      ),
  },
  {
    path: 'trade-plates',
    loadChildren: () =>
      import('../../components/trade-plate/trade-plate.module').then((m) => m.TradePlateModule),
  },
  {
    path: 'handover-times',
    loadChildren: () =>
      import('../../components/handover-times/handover-times.module').then(
        (m) => m.HandoverTimesModule,
      ),
  },
  {
    path: 'customer-sites',
    loadChildren: () =>
      import('../../components/customer-sites/customer-sites.module').then(
        (m) => m.CustomerSitesModule,
      ),
  },
  {
    path: 'organisation-task-types',
    loadChildren: () =>
      import('../../components/organisation-task-types/organisation-task-types.module').then(
        (m) => m.OrganisationTaskTypesModule,
      ),
  },
  {
    path: 'task-types-on-hold',
    loadChildren: () =>
      import('../../components/task-type-on-hold/task-type-on-hold.module').then(
        (m) => m.TaskTypeOnHoldModule,
      ),
  },
  {
    path: 'invoiceaddresses',
    loadChildren: () =>
      import('../../components/invoice-address/invoice-address-list.module').then(
        (m) => m.InvoiceAddressListModule,
      ),
  },
  {
    path: 'invoiceaddress',
    loadChildren: () =>
      import('../../components/invoice-address/invoice-address.module').then(
        (m) => m.InvoiceAddressModule,
      ),
  },
  {
    path: 'job-deployment/:id',
    loadChildren: () =>
      import('../../components/job-deployment/job-deployment.module').then(
        (m) => m.JobDeploymentModule,
      ),
  },
  {
    path: 'supplier-schedule-view',
    loadChildren: () =>
      import('../../components/supplier-schedule-view/supplier-schedule-view.module').then(
        (m) => m.SupplierScheduleViewModule,
      ),
  },
  {
    path: 'interactive-schedule',
    loadChildren: () =>
      import('../../components/interactive-schedule/interactive-schedule.module').then(
        (m) => m.InteractiveScheduleModule,
      ),
  },
  {
    path: 'supplier-schedule-planning-tool',
    loadChildren: () =>
      import(
        '../../components/supplier-schedule-planning-tool/supplier-schedule-planning-tool.module'
      ).then((m) => m.SupplierSchedulePlanningToolModule),
  },
  {
    path: 'supplierFeedback',
    loadChildren: () =>
      import('../../components/supplier-feedback/supplier-feedback.module').then(
        (m) => m.SupplierFeedbackModule,
      ),
  },
  {
    path: 'tagging-admin',
    loadChildren: () =>
      import('../../components/tagging-admin/tagging-admin.module').then(
        (m) => m.TaggingAdminModule,
      ),
  },
  {
    path: 'checklist-fees',
    loadChildren: () =>
      import('../../components/checklist-fees/checklist-fees.module').then(
        (m) => m.ChecklistFeesModule,
      ),
  },
  {
    path: 'supplier-tagging',
    loadChildren: () =>
      import('../../components/supplier-tagging/supplier-tagging.module').then(
        (m) => m.SupplierTaggingModule,
      ),
  },
  {
    path: 'supplieravailability',
    loadChildren: () =>
      import('../driver-experience/supplier-availability/supplier-availability.module').then(
        (m) => m.SupplierAvailabilityViewModule,
      ),
  },
  {
    path: 'incidents',
    loadChildren: () =>
      import('../../components/job-incidents/incidents-page.module').then(
        (m) => m.IncidentsPageModule,
      ),
  },
  {
    path: 'incident-closure-admin',
    loadChildren: () =>
      import('../../components/incident-closure-admin/incident-closure-admin.module').then(
        (m) => m.IncidentClosureAdminModule,
      ),
  },
  {
    path: 'incident-admin',
    loadChildren: () =>
      import('../../components/incident-admin/incident-admin.module').then(
        (m) => m.IncidentAdminModule,
      ),
  },
  {
    path: 'supplier-deactivation-admin',
    loadChildren: () =>
      import(
        '../../components/supplier-deactivation-admin/supplier-deactivation-admin.module'
      ).then((m) => m.SupplierDeactivationAdminModule),
  },
  {
    path: 'customer-user-deactivation-admin',
    loadChildren: () =>
      import(
        '../../components/customer-user-deactivation-admin/customer-user-deactivation-admin.module'
      ).then((m) => m.CustomerUserDeactivationAdminModule),
  },
  {
    path: 'email-template-designer',
    loadChildren: () =>
      import('../../components/email-template-designer/email-template-designer.module').then(
        (m) => m.EmailTemplateDesignerModule,
      ),
  },
  {
    path: 'comms-maintenance',
    loadChildren: () =>
      import('../../components/comms-maintenance/comms-maintenance.module').then(
        (m) => m.CommsMaintenanceModule,
      ),
  },
  {
    path: 'auto-job-match-settings',
    loadChildren: () =>
      import('../../components/auto-job-match/auto-job-match-settings.module').then(
        (m) => m.AutoJobMatchSettingsModule,
      ),
  },
  /*
  {
    path: 'callIncoming',
    loadChildren: () => import('').then(m => m.default)
  },
   */
  {
    path: 'organisation-custom-settings',
    loadChildren: () =>
      import(
        '../../components/organisation-custom-settings/organisation-custom-settings.module'
      ).then((m) => m.OrganisationCustomSettingsModule),
  },
  {
    path: 'manage-contract-type-history/:id',
    loadChildren: () =>
      import(
        '../../components/manage-contract-type-history/manage-contract-type-history.module'
      ).then((m) => m.ManageContractTypeHistoryModule),
  },
  {
    path: 'telephone-number-admin',
    loadChildren: () =>
      import(
        '../../components/telephony/telephone-number-admin/telephone-number-admin.module'
      ).then((m) => m.TelephoneNumberAdminModule),
  },
  {
    path: 'customer-invoice-report',
    loadChildren: () =>
      import('../../components/customer-invoice-report/customer-invoice-report.module').then(
        (m) => m.CustomerInvoiceReportModule,
      ),
  },
  {
    path: 'service-delivery-groups',
    loadChildren: () =>
      import('../../components/service-delivery-groups/service-delivery-groups.module').then(
        (m) => m.ServiceDeliveryGroupsModule,
      ),
  },
  {
    path: 'vme-interactive-schedule',
    loadChildren: () =>
      import(
        '../../components/interactive-schedule/vme-interactive-schedule/vme-interactive-schedule.module'
      ).then((m) => m.VMEInteractiveScheduleModule),
  },
  {
    path: 'supplier-interactive-schedule',
    loadChildren: () =>
      import(
        '../../components/interactive-schedule/supplier-interactive-schedule/supplier-interactive-schedule.module'
      ).then((m) => m.SupplierInteractiveScheduleModule),
  },
  {
    path: 'non-movement-descriptions',
    loadChildren: () =>
      import('../../components/non-movement-transactions/non-movement.module').then(
        (m) => m.NonMovementModule,
      ),
  },
  {
    path: 'delay-failure-admin',
    loadChildren: () =>
      import('../../components/delay-failure-admin/delay-failure-admin.module').then(
        (m) => m.DelayFailureAdminModule,
      ),
  },
  {
    path: 'delay-failure-templates',
    loadChildren: () =>
      import('../../components/delay-failure-templates/delay-failure-templates.module').then(
        (m) => m.DelayFailureTemplatesModule,
      ),
  },
  {
    path: 'driver-referral-link-admin',
    loadChildren: () =>
      import('../../components/driver-referral-link-admin/driver-referral-link-admin.module').then(
        (m) => m.DriverReferralLinkAdminModule,
      ),
  },
  {
    path: 'user-management-report',
    loadChildren: () =>
      import('../../components/users/user-management/user-management.module').then(
        (m) => m.UserManagementModule,
      ),
  },
  {
    path: 'cancellation-statuses',
    loadChildren: () =>
      import('../../components/cancellation-statuses/cancellation-statuses.module').then(
        (m) => m.CancellationStatusesModule,
      ),
  },
  {
    path: 'transactionsearch/:data',
    loadChildren: () =>
      import(
        '../../components/non-movement-transactions/search-non-movement-transactions/search-non-movement-transactions.module'
      ).then((m) => m.TransactionsSearchModule),
  },
  {
    path: 'interactions',
    loadChildren: () =>
      import('../../components/interactions/interactions-list/interactions-list.module').then(
        (m) => m.InteractionsListModule,
      ),
  },
  {
    path: 'interactions-report',
    loadChildren: () =>
      import('../../components/interactions/interactions-report/interactions-report.module').then(
        (m) => m.InteractionsReportModule,
      ),
  },
  {
    path: 'interaction-category-admin',
    loadChildren: () =>
      import(
        '../../components/interactions/interaction-category-admin/interaction-category-admin.module'
      ).then((m) => m.InteractionCategoryAdminModule),
  },
  {
    path: 'supplier-information/:id',
    loadChildren: () =>
      import('../../components/telephony/supplier-information/supplier-information.module').then(
        (m) => m.SupplierInformationModule,
      ),
  },
  {
    path: 'customer-information/:id',
    loadChildren: () =>
      import('../../components/telephony/customer-profile/customer-information.module').then(
        (m) => m.CustomerInformationModule,
      ),
  },
  {
    path: 'job',
    loadChildren: () => import('../../components/job/job.module').then((m) => m.JobModule),
  },
  {
    path: 'organisation-additional-charge-types',
    loadChildren: () =>
      import(
        '../../components/organisation-additional-charge-type/organisation-additional-charge-type.module'
      ).then((m) => m.OrganisationAdditionalChargeTypeModule),
  },
  {
    path: 'cost-rejection-reasons',
    loadChildren: () =>
      import('../../components/cost-rejection-reasons/cost-rejection-reasons.module').then(
        (m) => m.CostRejectionReasonsModule,
      ),
  },
  {
    path: 'additional-cost-questions',
    loadChildren: () =>
      import('../../components/additional-cost-questions/additional-cost-questions.module').then(
        (m) => m.AdditionalCostQuestionsModule,
      ),
  },
  {
    path: 'telephony-users',
    loadChildren: () =>
      import('../../components/telephony/telephony-users/telephony-users.module').then(
        (m) => m.TelephonyUsersModule,
      ),
  },
  {
    path: 'telephony-webhooks',
    loadChildren: () =>
      import('../../components/telephony/telephony-webhooks/telephony-webhooks.module').then(
        (m) => m.TelephonyWebhooksModule,
      ),
  },
  {
    path: 'supplier-profile',
    loadChildren: () =>
      import('../../components/gamification/supplier-view/gamification-container.module').then(
        (m) => m.GamificationModule,
      ),
  },
  {
    path: 'banner-management',
    loadChildren: () =>
      import('../../components/banner-management/banner-management-container.module').then(
        (m) => m.BannerManagementContainerModule,
      ),
  },
  {
    path: 'job-rejection-reasons',
    loadChildren: () =>
      import('../../components/manage-job-rejection/manage-job-rejection.module').then(
        (m) => m.ManageJobRejectionModule,
      ),
  },
  {
    path: 'order-limits-admin',
    loadChildren: () =>
      import('../../components/customer-order-limits/customer-order-limits.module').then(
        (m) => m.CustomerOrderLimitsModule,
      ),
  },
  {
    path: 'order-creation-notification-admin',
    loadChildren: () =>
      import(
        '../../components/order-creation-notification-admin/order-creation-notification-admin.module'
      ).then((m) => m.OrderCreationNotificationAdminModule),
  },
  {
    path: 'ratecard-admin',
    loadChildren: () =>
      import('../../components/preset-ratecard-admin/preset-ratecard-admin.module').then(
        (m) => m.PresetRateCardAdminModule,
      ),
  },
  {
    path: 'supplier-availability-dashboard',
    loadChildren: () =>
      import(
        '../../components/supplier-availability-dashboard/supplier-availability-dashboard.module'
      ).then((m) => m.SupplierAvailabilityDashboardModule),
  },
  {
    path: 'vehiclelifecycle',
    loadChildren: () =>
      import('../../components/vehicle-lifecycle/vehicle-lifecycle.module').then(
        (m) => m.VehicleLifeCycleModule,
      ),
  },
  {
    path: 'route-algo-admin',
    loadChildren: () =>
      import('../../components/route-algo-admin/route-algo-admin.module').then(
        (m) => m.RouteAlgoAdminModule,
      ),
  },
  {
    path: 'amazon-inspection',
    loadChildren: () =>
      import('../../components/amazon-inspection/amazon-inspection.module').then(
        (m) => m.AmazonInspectionModule,
      ),
  },
  {
    path: 'travel-scheduler/:id',
    loadChildren: () =>
      import('../../components/travel-scheduler/travel-scheduler/travel-scheduler.module').then(
        (m) => m.TravelSchedulerModule,
      ),
  },
  {
    path: 'supplier-risk-management',
    loadComponent: () =>
      import('../../components/supplier-risk-management/supplier-risk-management.component').then(
        (mod) => mod.SupplierRiskManagementComponent,
      ),
  },
  {
    path: 'order-booking-health-check',
    loadComponent: () =>
      import(
        '../../components/order-booking-health-check/order-booking-health-check.component'
      ).then((mod) => mod.OrderBookingHealthCheckComponent),
  },
  {
    path: 'order-booking-check-configuration',
    loadComponent: () =>
      import(
        '../../components/order-booking-check-configuration/order-booking-check-configuration.component'
      ).then((mod) => mod.OrderBookingCheckConfigurationComponent),
  },
  {
    path: 'job-hold-configuration',
    loadComponent: () =>
      import('../../components/job-hold-configuration/job-hold-configuration.component').then(
        (m) => m.JobHoldConfigurationComponent,
      ),
  },
  {
    path: 'fuel-price-adjuster',
    loadComponent: () =>
      import('../../components/fuel-price-adjuster/fuel-price-adjuster.component').then(
        (m) => m.FuelPriceAdjusterComponent,
      ),
  },
];

/**
 * Routing for post-authenticated routes (/app)
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppAuthenticatedRoutingModule {}
